var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.field.subtype == 'select')?_c('custom-select',{attrs:{"options":_vm.field.options,"value":_vm.value},on:{"input":_vm.onInput}}):_c('radio-select',{attrs:{"type":_vm.field.subtype,"options":_vm.field.options,"value":_vm.value,"inline":_vm.field.inline},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }